export enum ROUTES {
	DEAL = '/deal/:dealId',
	DASHBOARD = '/dashboard',
	DEAL_CREATE = '/deal/create',
	TEMPLATES = '/templates',
	AUTH = '/auth',
	PAGE_NOT_FOUND = '/404',
	EXPORT = '/exports',
	PROFILE = '/profile',
	GENERIC_ERROR = '/error',
	TERMS = '/terms',
	PRIVACY = '/privacy',
	ORGANIZATIONS = '/organizations',
	ORGANIZATION_BY_ID = '/organizations/:organizationId',
	HELP_BLOG = '/help',
	EID_EASY_FTN_CALLBACK = '/eid-easy/ftn-callback',
	EID_EASY_OTP_CALLBACK = '/eid-easy/otp-callback',
}

export const DEFAULT_PROTECTED_ROUTE = ROUTES.DASHBOARD;

export enum AUTH_ROUTES {
	LOGIN = '/login',
	REGISTER = '/register',
	CHANGE_EMAIL = '/change-email',
	CANCEL_EMAIL_CHANGE = '/cancel-email-change',
	INVITATION_EXPIRED = '/invitation-expired',
}

export enum LEGACY_AUTH_ROUTES {
	RESET_PASSWORD = '/reset-password',
	INVITATION = '/register',
}

export const DEFAULT_GUEST_ROUTE = `${ROUTES.AUTH}${AUTH_ROUTES.LOGIN}`;

export enum MIP_ROUTES {
	CREATE = '/create',
	MANAGE = '/manage',
	MESSAGES = '/messages/investor/:investorId',
}

export enum DEAL_ROUTES {
	DETAILS = '',
	SETTINGS = '/settings',
	MIP = '/mip/:mipId',
	PEOPLE = '/people/:personId',
	CAP_TABLE = '/cap-table',
	CAP_CHART = '/cap-table/chart',
	WATERFALL = '/valuations',
	WATERFALL_DETAILS = '/valuations/:valuationId',
	DOCUMENT_LIBRARY = '/document-library',
	EVENT_LOG = '/event-log',
	EVENT_LOG_MESSAGE = '/event-log/message/:messageId',
	// Temporary: main's shipped feed, kept alongside the CAP-2060 redesign for comparison
	EVENT_LOG_CURRENT = '/event-log-current',
	BATCH_ANALYSIS = '/analysis/:batchId',
}

export enum PEOPLE_ROUTES {
	INITIAL = '',
	PERSON_DETAILS = '/details',
	PERSON_HISTORY = '/history',
	SECURITIES = '/securities',
	SECURITY_DETAILS = '/securities/:securityId',
	SECURITY_RANKING = '/security-ranking',
	TRANSACTIONS = '/transactions',
	TRANSACTION_DETAILS = '/transactions/:transactionId',
	HOLDINGS = '/holdings',
	HOLDING_DETAILS = '/holdings/details',
	OWNERSHIP = '/ownership',
	DOCUMENTS = '/documents',
}

export enum DEAL_SETTINGS_ROUTES {
	GENERAL = '',
	MEMBERS = '/members',
	CLASSIFIERS = '/classifiers',
	USER = '/user/:userId',
	EMAIL_TEMPLATES = '/email-templates',
	EMAIL_TEMPLATE_DETAIL = '/email-templates/:templateType',
}

export enum PROGRAMME_SETTINGS_ROUTES {
	GENERAL = '',
	MEMBERS = '/members',
	SECURITIES = '/securities',
	LOANS = '/loans',
	DOCUMENTS = '/documents',
	USER_BASE = '/user',
	USER = '/user/:userId',
	KYC_SETTINGS = '/kyc',
	INVESTOR_DATA = '/data',
	TAX = '/tax',
	CLASSIFIERS = '/classifiers',
	EMAIL_TEMPLATES = '/email-templates',
	EMAIL_TEMPLATE_DETAIL = '/email-templates/:templateType',
	AUTOMATED_EMAILS = '/automated-emails',
}

export enum MIP_MANAGE_ROUTES {
	INVESTORS = '/investors',
	INVESTMENTS = '/investments',
	INVESTMENT_DETAILS = '/investments/:investmentId',
	INVESTMENT_HISTORY = '/investments/:investmentId/history',
	CONTRACTS = '/contracts',
	DOCUMENTS = '/documents',
	DOCUMENT_DETAILS = '/documents/:documentWorkflowInstanceId',
	KYC = '/kyc',
	KYC_PAGE = '/kyc-page',
	PAYMENTS = '/payments',
	BANK_ACCOUNTS = '/bank-accounts',
	BANK_ACCOUNT_DETAILS = '/bank-accounts/:bankAccountId',
	SETTINGS = '/settings',
	INVESTOR_DETAILS = '/investors/:investorId',
	INVESTMENT_VEHICLE_DETAILS = '/investors/investment-vehicles/:personId',
}
